import React from 'react';
import { JsonLd } from 'react-schemaorg';
import map from 'lodash/map';
import get from 'lodash/get';
import { I18nHoc } from 'helpers/i18n';
import absoluteUrl from 'helpers/absoluteUrl';
import { AbstractObjectTile, TileView } from 'components/layouts';
import Link from 'components/link';

import linksDomik from 'src-sites/domik/links';

import translates from '../section-projects/card-i18n';

import 'styles/domik/section-projects/_view-tile.scss';

@I18nHoc(translates())
export default class StockCardNews extends AbstractObjectTile {
  static displayName = 'StockCardNews';

  constructor(props, ctx) {
    super(props, ctx);
    this.imagesKey = 'others';
  }

  renderDeveloperLink(developers, bemClasses) {
    const developer = get(developers, '[0]', {});
    if (!developer.url || !developer.name_short) return null;

    return (
      <Link
        {...bemClasses('link', 'fill')}
        builder={linksDomik.sectionLanding}
        builderProps={{
          ...developer,
          title: developer.name_short
        }}
        children={<span children={developer.name_short}/>}
      />
    );
  }

  renderImage(data, bemClasses) {
    const { i18n } = this;
    const image = get(data, 'title_image.id');
    const type = get(data, 'type') === 'living_complex' ? i18n('forApartments') : null;
    const header = get(data, 'display_name') || get(data, 'location_path');
    const locality = get(data, 'parent_display_path') ? `, ${get(data, 'parent_display_path')}` : null;
    const alt = `${i18n('stock')}${type} в ${header}${locality}` || '';
    const title = `${i18n('stock')} в ${data.display_name}` || null;
    const dataImg = { alt, title };

    return (
      <>
        {super.renderImage(data, bemClasses, false, false, true, dataImg)}
        {/*renderSignOfAvailabilityStock(bemClasses, data.stocks_array)*/}
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'ImageObject',
            name: alt || null,
            description: title,
            contentLocation: get(data, 'parent_display_path', null),
            contentUrl: image ? absoluteUrl(`/images/thumb/full/${image}`) : null
          }}
        />
      </>
    );
  }

  renderContent(data = {}, bemClasses) {
    const { i18n } = this;
    const {
      stocks_array, developers,
    } = data;
    const stockItem = {};
    const stockItemSeo = {};
    map(stocks_array, (it) => {

      stockItem.title = it.title_domik && <div {...bemClasses('description')}><span {...bemClasses('text', 'description')} children={it.title_domik} /></div>;
      stockItemSeo.title = `\ud83d\udd36 ${get(it, 'title_domik')}`;
      stockItemSeo.link = get(it, 'link');
      stockItemSeo.discount = get(it, 'discount');
      stockItemSeo.image = get(data, 'title_image.id');
      stockItemSeo.displayName = get(data, 'display_name');
      stockItemSeo.geo = get(data, 'geo_centroid');
      stockItemSeo.url = get(data, 'url');
    });
    const header = data.display_name || data.location_path;

    return (
      <>
        {header &&
          <div {...bemClasses('location')}>
            <span {...bemClasses('text')} children={header} />
          </div>
        }
        {this.renderDeveloperLink(developers, bemClasses)}
        {stockItem.title}
        {stockItemSeo &&
          <JsonLd
            item={{
              '@context': 'https://schema.org',
              '@type': 'SaleEvent',
              name: stockItemSeo.title,
              startDate: stockItemSeo.from,
              endDate: stockItemSeo.to,
              url: stockItemSeo.link,
              description: stockItemSeo.discount,
              image: stockItemSeo.image ? absoluteUrl(`/images/thumb/full/${stockItemSeo.image}`) : null,
              location: {
                '@type': 'Place',
                address: stockItemSeo.addressLocality ? {
                  '@type': 'PostalAddress',
                  addressLocality: stockItemSeo.addressLocality
                } : null,
                name: stockItemSeo.displayName,
                geo: stockItemSeo.geo && stockItemSeo.geo.type === 'Point' ? {
                  '@type': 'GeoCoordinates',
                  latitude: stockItemSeo.geo.coordinates[1],
                  longitude: stockItemSeo.geo.coordinates[0]
                } : null,
              },
              about: stockItemSeo.title,
              performer: stockItemSeo.displayName,
              organizer: 'Domik.ua',
              offers: stockItemSeo.price ? {
                '@type': 'Offer',
                price: stockItemSeo.price,
                priceCurrency: stockItemSeo.priceCurrency,
                availability: stockItemSeo.sold ? 'https://schema.org/SoldOut' : 'https://schema.org/InStock',
                url: absoluteUrl(stockItemSeo.url),
                validFrom: stockItemSeo.from
              } : null
            }}
          />
        }
      </>
    );
  }

  renderSideBlock() {
    return null;
  }

  renderUnderneath(data = {}, bemClasses) {
    const { stocks_array, display_name, location_path } = data;
    const header = display_name || location_path;
    const stockItem = {};
    map(stocks_array, (it) => {
      stockItem.link = it.link && (
        <Link
          {...bemClasses('link', 'fill')}
          href={it.link}
          rel="nofollow"
          dataProps={header ? { 'data-gtm-zhk': header } : null}
          external
          blank
          children={<span />}
        />
      );
    });

    return stockItem.link;
  }

  render() {
    const { object, dataMods, ...restProps } = this.props;

    return (
      <TileView
        {...restProps}
        data={object}
        dataMods={{ fill: false, domik: true, stock: true, articles: true, ...dataMods }}
        linkCard={{ filledCard: false, filledImg: false }}
        renderImage={this.renderImage}
        renderContent={this.renderContent}
        renderSideBlock={this.renderSideBlock}
        renderUnderneath={this.renderUnderneath}
      />
    );
  }
}
